<template>
  <div class="card-body">
    <ul class="chat list-unstyled">
      <li v-if="messages.length === 0" class="text-center text-muted">
        No messages
      </li>
      <chat-message
        v-for="message in messages"
        :key="message.id"
        :message="message"
        :auth_id="auth_id"
        :observer="observer"
        :msg_user="message.user.id"
      />
    </ul>
  </div>
</template>

<script>
import axios from 'axios';
import { format, isToday, isThisYear, formatDistanceToNow, parseISO } from 'date-fns';
import { EventBus } from './../eventBus';
import ChatMessage from './ChatMessage.vue';
import { ta } from 'date-fns/locale';

export default {
  props: ["chanel", "hash", "auth_id"],
  data() {
    return {
      messages: [],
      observer: null,
      undeadCountEBName: 'user-'+this.auth_id+'-unread-count-changed'
    };
  },
  components: {
    ChatMessage
  },
  created() {
    this.observer = new IntersectionObserver(
      this.onElementObserved,
      {
        root: this.$el,
        threshold: 1.0,
      }
    );
    EventBus.$on('custom-event', (payload) => {
      this.messages.push({
        id: Date.now(),
        message: payload.message,
        user: payload.user,
        time: 'now',
      });
    });
  },
  beforeDestroy() {
    EventBus.$off('custom-event');
    this.observer.disconnect();
  },
  mounted() {
    this.fetchMessages();
    this.setupChannel();
  },
  methods: {
    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) {
          return;
        }
        this.observer.unobserve(target);
        let isMine= target.getAttribute("mine");
        let messageId= target.getAttribute("id");
        let msg_user= target.getAttribute("msg_user");
        if(!isMine && target.querySelector('p').classList.contains('new-message')){
          axios.get(`/account/private-chat/messages/${messageId}/mark-as-read`)
            .then(response => {
              if (response.data.success) {
                target.querySelector('p').classList.remove('new-message');
                EventBus.$emit('user-'+msg_user+'-unread-count-changed', 1);
              } 
            })
            .catch(error => {
              console.error('Error marking message as read:', error);
            });
        }
      });
    },
    fetchMessages() {
      axios.post(`/account/private-chat/messages/${this.hash}`)
        .then(response => {
          if (Array.isArray(response.data.messages)) {
            this.messages = response.data.messages.map(message => ({
              id: message.id,
              message: message.message,
              user: message.user,
              time: this.formatTime(message.time),
              read_at: message.read_at
            }));
          } else {
            console.error('Expected an array of messages');
          }
        })
        .catch(error => {
          console.error('Error fetching messages:', error);
        });
    },
    setupChannel() {
      const channelName = `chat-${this.chanel}`;
      window.Echo.private(channelName)
        .listen('ChatMessageSent', e => {
          const newMessage = {
            id: e.message.id,
            message: e.message.content,
            user: e.user,
            time: this.formatTime(e.message.created_at),
          };
          this.messages.push(newMessage);
        });
    },
    formatTime(time) {
      const parsedTime = parseISO(time);

      if (isToday(parsedTime)) {
        return formatDistanceToNow(parsedTime, { addSuffix: true });
      } else if (isThisYear(parsedTime)) {
        return format(parsedTime, 'do MMMM');
      } else {
        return format(parsedTime, 'do MMMM yyyy');
      }
    }
  },
};
</script>
